"use client";

import { useEffect, useState } from "react";
import DOMPurify from "dompurify";

import { cn } from "@/lib/utils";

export default function RichHtml({
    html,
    className,
}: {
    html: string;
    className?: string;
}) {
    const [out, setOut] = useState("");
    useEffect(() => setOut(DOMPurify.sanitize(html)), [html]);

    if (!html) return null;

    return (
        <div
            className={cn("lomda-v3-rich-text", className)}
            dangerouslySetInnerHTML={{ __html: out }}
        />
    );
}
